import { complianceEndpoints } from './handlers/exampleCompliance';
import { complianceDocumentEndpoints } from './handlers/compliance';
import { authEndpoints } from './handlers/auth';
import { imageEndpoints } from './handlers/images';
import { accessControlEndpoints } from './handlers/accessControl';
import { taskEndpoints } from './handlers/task';
import { genericEndpoints } from './handlers/genericData';
import { suppliersEndpoints } from './handlers/suppliers';
import { viewsEndpoints } from './handlers/views';
import { t } from '@lingui/macro';
import { VITE_MOCK_ONLY } from 'config';
import type { Server } from 'miragejs';
import { facilitiesEndpoints } from './handlers/facilities';
import { supplierAccessEndpoints } from './handlers/supplierAccess';
import { purchaseOrdersEndpoints } from './handlers/purchaseOrders';
import { purchaseOrdersMappingEndpoints } from './handlers/purchaseOrdersMapping';
import { purchaseOrdersReviewEndpoints } from './handlers/purchaseOrdersReview';
import { itemsEndpoints } from './handlers/items';
import { HTTP_RESPONSE_CODES } from '../constants';

const enabledEndpoints = (server: Server) => {
  complianceEndpoints(server);
  complianceDocumentEndpoints(server);
  imageEndpoints(server);
  accessControlEndpoints(server);
};

const disabledEndpoints = (server: Server) => {
  authEndpoints(server);
  suppliersEndpoints(server);
  taskEndpoints(server);
  facilitiesEndpoints(server);
  genericEndpoints(server);
  purchaseOrdersEndpoints(server);
  purchaseOrdersMappingEndpoints(server);
  purchaseOrdersReviewEndpoints(server);
  supplierAccessEndpoints(server);
  viewsEndpoints(server);
  itemsEndpoints(server);
};

export const endpoints = (server: Server) => {
  enabledEndpoints(server);
  if (VITE_MOCK_ONLY) {
    disabledEndpoints(server);
  }
};

export { HTTP_RESPONSE_CODES };

export const ERROR_MESSAGES = {
  [HTTP_RESPONSE_CODES.NO_CHANGE]: t`204 No change`,
  [HTTP_RESPONSE_CODES.BAD_INPUT]: t`400 Bad input`,
  [HTTP_RESPONSE_CODES.UNAUTHORIZED]: t`'401 User is not authorised`,
  [HTTP_RESPONSE_CODES.BAD_INPUT]: t`403 Action not allowed`,
  [HTTP_RESPONSE_CODES.ENTITY_NOT_FOUND]: t`404 Entity not found`,
  [HTTP_RESPONSE_CODES.SERVER_ERROR]: t`500 Server error`,
};
